export default {
    mapGeofenceBulk_title: "Acciones masivas para las geocercas",
    mapGeofenceBulk_iconType: "Tipo de Ícono",
    mapGeofenceBulk_Icon_color: "Ícono & Color",
    mapGeofenceBulk_geofence: "Geocercas actualizadas",
    mapGeofenceBulk_geofence_selected: "Geocercas seleccionadas",
    mapGeofenceBulk_selectedGeofences: "Las Geocercas seleccionados pertenecen a los siguientes grupos",
    mapGeofenceBulk_tag: "Etiqueta",
};